import loc from 'owa-localize';
import {
    toggleBoardLockAssetsTooltip,
    toggleBoardLockBoardTooltip,
} from 'owa-calendar-shared-strings/lib/strings/calendarSurfaceCommandBar.locstring.json';

export function getLockBoardButtonTooltip(): string {
    return loc(toggleBoardLockBoardTooltip);
}

export function getLockAssetsButtonTooltip(): string {
    return loc(toggleBoardLockAssetsTooltip);
}
